import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Volume2 } from "lucide-react";
import { useToast } from "@/components/ui/use-toast";

// Array emoji lucu untuk badge
const EMOJIS = [
  '🐶', '🐱', '🐭', '🐹', '🐰', '🦊', '🐻', '🐼', '🐨', '🐯', '🦁', '🐮',
  '🐷', '🐸', '🐵', '🐔', '🐧', '🐦', '🐤', '🦄', '🦉', '🐝', '🦋', '🐌',
  '🐞', '🐙', '🦑', '🦀', '🐡', '🐠', '🐬', '🐳', '🐊', '🐅', '🦓', '🦒',
  '🐘', '🦏', '🐪', '🐫', '🌵', '🎄', '🌲', '🌳', '🌴', '🌱', '🌿', '☘️',
  '🍀', '🎍', '🍎', '🍐', '🍊', '🍋', '🍌', '🍉', '🍇', '🍓', '🍈', '🍒',
  '🍑', '🍍', '🥝', '🍅', '🥥', '🥕', '🌽', '🥔', '🍠', '🥐', '🍞', '🥖',
  '🥨', '🧀', '🍗', '🍖', '🌭', '🍔', '🍟', '🍕', '🥪', '🥗', '🍝', '🍜',
  '🍣', '🍤', '🍦', '🍩', '🍪', '🎂', '🍫', '🍬', '🍭', '🍮', '🍯', '🍼',
  '☕', '🍵', '🍶', '🍾', '🎈', '🎉', '🎊', '🎁', '🎀', '🎗️', '🎟️', '🎫',
  '🎮', '🎯', '🎲', '🎳', '🎨', '🎪', '🎤', '🎧', '🎹', '🥁', '🎷', '🎺',
  '🎸', '🎻', '🎭', '🤹', '🎯', '🎗️', '🏆', '🏅', '🎖️', '🥇', '🥈', '🥉',
  '⚽', '🏀', '🏈', '⚾', '🎾', '🏐', '🏉', '🎱', '🏓', '🏸', '🥅', '🏒',
  '🏑', '🏏', '⛳', '🏹', '🎣', '🚗', '🚕', '🚙', '🚌', '🚎', '🏎️', '🚓',
  '🚑', '🚒', '🚐', '🚚', '🚛', '🚜', '🛴', '🚲', '🛵', '🏍️', '🚨', '🚔',
  '🚍', '🚘', '🚖', '🚡', '🚠', '🚟', '🚃', '🚋', '🚞', '🚝', '🚄', '🚅',
  '🚈', '🚂', '🚆', '🚇', '🚊', '🚉', '✈️', '🛫', '🛬', '🛩️', '💺', '🚀',
  '🛸', '🚁', '🛶', '⛵', '🚤', '🛥️', '🛳️', '⛴️', '🚢', '⚓', '⛽', '🚧',
  '🚦', '🚥', '🗼', '🗽', '⛲', '🗾', '🎡', '🎢', '🎠', '⛱️', '🏖️', '🏝️',
  '🏜️', '🌋', '⛰️', '🏔️', '🗻', '🏕️', '⛺', '🏠', '🏡', '🏘️', '🏚️', '🏗️',
  '🏢', '🏭', '🏣', '🏤', '🏥', '🏦', '🏨', '🏪', '🏫', '🏩', '💒', '🏛️',
  '⛪', '🕌', '🕍', '🕋', '🛕', '⛩️', '🛤️', '🛣️', '🗾', '🎑', '🏞️', '🌅',
  '🌄', '🌠', '🎇', '🎆', '🌇', '🌆', '🏙️', '🌃', '🌌', '🌉', '🌁', '⌚',
  '📱', '📲', '💻', '⌨️', '🖥️', '🖨️', '🖱️', '🖲️', '🕹️', '🗜️', '💽', '💾',
  '💿', '📀', '📼', '📷', '📸', '📹', '🎥', '📽️', '🎞️', '📞', '☎️', '📟',
  '📠', '📺', '📻', '🎙️', '🎚️', '🎛️', '🧭', '⏱️', '⏲️', '⏰', '🕰️', '⌛',
  '⏳', '📡', '🔋', '🔌', '💡', '🔦', '🕯️', '🪔', '🧯', '🛢️', '💸', '💵',
  '💴', '💶', '💷', '💰', '💳', '💎', '⚖️', '🧰', '🔧', '🔨', '⚒️', '🛠️',
  '⛏️', '🔩', '⚙️', '🧱', '⛓️', '🧲', '🔫', '💣', '🧨', '🪓', '🔪', '🗡️',
  '⚔️', '🛡️', '🚬', '⚰️', '⚱️', '🏺', '🔮', '📿', '🧿', '💈', '⚗️', '🔭',
  '🔬', '🕳️', '💊', '💉', '🩸', '🧬', '🦠', '🧫', '🧪', '🌡️', '🧹', '🧺',
  '🧻', '🚽', '🚰', '🚿', '🛁', '🧼', '🪒', '🧽', '🧴', '🛎️', '🔑', '🗝️',
  '🚪', '🪑', '🛋️', '🛏️', '🛌', '🧸', '🖼️', '🛍️', '🛒', '🎁', '🎈', '🎏',
  '🎀', '🎊', '🎉', '🎎', '🏮', '🎐', '🧧', '✉️', '📩', '📨', '📧', '💌',
  '📥', '📤', '📦', '🏷️', '📪', '📫', '📬', '📭', '📮', '📯', '📜', '📃',
  '📄', '📑', '🧾', '📊', '📈', '📉', '🗒️', '🗓️', '📆', '📅', '🗑️', '📇',
  '🗃️', '🗳️', '🗄️', '📋', '📁', '📂', '🗂️', '📌', '📍', '📎', '🖇️', '📏',
  '📐', '✂️', '🗃️', '🗄️', '🗑️', '🔒', '🔓', '🔏', '🔐', '🔑', '🗝️', '🔨',
  '🪓', '⛏️', '⚒️', '🛠️', '🗡️', '⚔️', '🔫', '🏹', '🛡️', '🔧', '🔩', '⚙️',
  '🗜️', '⚗️', '⚖️', '🔗', '⛓️', '🧰', '🧲', '🧪', '🧫', '🧬', '🔬', '🔭',
  '📡', '💉', '🩸', '💊', '🩹', '🩺', '🚪', '🛏️', '🛋️', '🪑', '🚽', '🚿',
  '🛁', '🧴', '🧷', '🧹', '🧺', '🧻', '🧼', '🧽', '🧯', '🛒', '🚬', '⚰️',
  '⚱️', '🏺', '🔮', '📿', '🧿', '💈', '🎊', '🎉', '🎎', '🎏', '🎐', '🎀',
  '🎁', '🎗️', '🎟️', '🎫', '🎮', '🎭', '🎨', '🧵', '🧶', '🎼', '🎵', '🎶',
  '🎤', '🎧', '🎷', '🎸', '🎹', '🎺', '🎻', '🥁', '🪘', '🪗', '🎸', '🎷',
  '🎺', '🎻', '🪕', '🎻', '🎸', '🎷', '🎺', '🪕', '🎻', '🥁', '🪘', '🪗',
  '🎸', '🎷', '🎺', '🎻', '🪕', '🎸', '🎷', '🎺', '🎻', '🪕', '🥁', '🪘'
];

// Fungsi untuk mendapatkan emoji acak berdasarkan posisi kartu
const getRandomEmoji = (row: number, col: number) => {
  const index = (row * 10 + col) % EMOJIS.length;
  return EMOJIS[index];
};

const MultiplicationTable = () => {
  const [selectedNumber, setSelectedNumber] = useState(1);
  const [hoveredCell, setHoveredCell] = useState<{ row: number; col: number } | null>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const { toast } = useToast();
  const apiKey = "sk_2dca050b6ead0fbd7c45e06bb22c18447d236ee8a7bdcff4";

  const generateTable = () => {
    const table = [];
    for (let i = 1; i <= 12; i++) {
      const row = [];
      for (let j = 1; j <= 12; j++) {
        row.push(i * j);
      }
      table.push(row);
    }
    return table;
  };

  const table = generateTable();

  const speakResult = async (text: string) => {
    setIsPlaying(true);
    try {
      const response = await fetch('https://api.elevenlabs.io/v1/text-to-speech/XB0fDUnXU5powFXDhCwa', {
        method: 'POST',
        headers: {
          'Accept': 'audio/mpeg',
          'Content-Type': 'application/json',
          'xi-api-key': apiKey
        },
        body: JSON.stringify({
          text: text,
          model_id: 'eleven_multilingual_v2',
          voice_settings: {
            stability: 0.5,
            similarity_boost: 0.5
          }
        })
      });

      if (response.ok) {
        const audioBlob = await response.blob();
        const audioUrl = URL.createObjectURL(audioBlob);
        const audio = new Audio(audioUrl);
        
        audio.onended = () => {
          setIsPlaying(false);
          URL.revokeObjectURL(audioUrl);
        };
        
        await audio.play();
      } else {
        throw new Error('Gagal membuat audio');
      }
    } catch (error) {
      console.error('Error:', error);
      toast({
        title: "Error",
        description: "Gagal memutar audio. Periksa API Key Anda.",
        variant: "destructive"
      });
      setIsPlaying(false);
    }
  };

  const colors = [
    "bg-red-100 border-red-300 text-red-800 hover:bg-red-200",
    "bg-orange-100 border-orange-300 text-orange-800 hover:bg-orange-200", 
    "bg-yellow-100 border-yellow-300 text-yellow-800 hover:bg-yellow-200",
    "bg-green-100 border-green-300 text-green-800 hover:bg-green-200",
    "bg-blue-100 border-blue-300 text-blue-800 hover:bg-blue-200",
    "bg-indigo-100 border-indigo-300 text-indigo-800 hover:bg-indigo-200",
    "bg-purple-100 border-purple-300 text-purple-800 hover:bg-purple-200",
    "bg-pink-100 border-pink-300 text-pink-800 hover:bg-pink-200",
    "bg-rose-100 border-rose-300 text-rose-800 hover:bg-rose-200",
    "bg-cyan-100 border-cyan-300 text-cyan-800 hover:bg-cyan-200",
    "bg-emerald-100 border-emerald-300 text-emerald-800 hover:bg-emerald-200",
    "bg-violet-100 border-violet-300 text-violet-800 hover:bg-violet-200"
  ];

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-2xl shadow-lg p-6 max-w-2xl mx-auto border border-gray-100">
        <div className="text-center mb-6">
          <h2 className="text-2xl font-bold text-gray-800 mb-2">Pilih Angka Favorit Kamu!</h2>
        </div>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <div className="relative w-32">
            <Input
              type="number"
              min="1"
              max="100"
              value={selectedNumber}
              onChange={(e) => setSelectedNumber(parseInt(e.target.value) || 1)}
              className="w-full text-center text-2xl font-bold h-14 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all"
            />
            <div className="absolute inset-y-0 right-0 flex flex-col border-l border-gray-200">
              <button 
                onClick={() => setSelectedNumber(prev => Math.min(prev + 1, 100))}
                className="flex-1 flex items-center justify-center px-2 text-gray-500 hover:bg-gray-50 rounded-tr-lg"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                </svg>
              </button>
              <div className="border-t border-gray-200"></div>
              <button 
                onClick={() => setSelectedNumber(prev => Math.max(prev - 1, 1))}
                className="flex-1 flex items-center justify-center px-2 text-gray-500 hover:bg-gray-50 rounded-br-lg border-t border-gray-200"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
            </div>
          </div>
          
          <button 
            className="px-6 py-3.5 bg-gradient-to-r from-blue-500 to-blue-600 text-white font-medium rounded-xl hover:opacity-90 transition-opacity shadow-md hover:shadow-lg w-full sm:w-auto"
            onClick={() => {
              // Regenerate table or any other action
            }}
          >
            Tampilkan Tabel
          </button>
        </div>
      </div>

      <div className="text-center mb-4">
        <p className="text-sm text-muted-foreground">Klik pada kotak untuk mendengarkan hasil perkalian!</p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
        {Array.from({ length: 12 }, (_, i) => {
          const multiplier = i + 1;
          const result = selectedNumber * multiplier;
          const colorClass = colors[i % colors.length];
          
          return (
            <Card
              key={i}
              className={`${colorClass} border-2 cursor-pointer transition-all duration-300 hover:scale-110 hover:shadow-lg transform`}
              onClick={() => setHoveredCell({ row: selectedNumber - 1, col: i })}
            >
              <CardContent className="p-4 text-center">
                <div className="text-lg font-bold">
                  {selectedNumber} × {multiplier}
                </div>
                <div 
                  className="text-2xl font-black animate-pulse flex items-center justify-center gap-2 cursor-pointer hover:scale-110 transition-transform"
                  onClick={() => speakResult(`${selectedNumber} kali ${multiplier} sama dengan ${result}`)}
                >
                  = {result}
                  <Volume2 
                    className={`w-5 h-5 ${isPlaying ? 'text-primary animate-pulse' : 'text-muted-foreground'}`}
                  />
                </div>
                <Badge variant="secondary" className="mt-2 text-base text-white">
                  <span className="text-xl">
                    {result <= 12 
                      ? `Mudah! ${getRandomEmoji(selectedNumber, multiplier)}` 
                      : result <= 24 
                        ? `Lanjut! ${getRandomEmoji(selectedNumber + 1, multiplier + 1)}` 
                        : result <= 48 
                          ? `Hebat! ${getRandomEmoji(selectedNumber + 2, multiplier + 2)}` 
                          : `Luar Biasa! ${getRandomEmoji(selectedNumber + 3, multiplier + 3)}`}
                  </span>
                </Badge>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
};

export default MultiplicationTable;